import { createFeature, createReducer, on } from '@ngrx/store';
import { EmptyAddress } from 'clicklease-ui-elements';
import { BusinessInformation, BusinessInformationState } from './../../interfaces/business-information';
import {
    LoadBusinessInfoAction,
    ResetBusinessInfoAction,
    SetBusinessInfoAction,
} from './business-information.actions';

const initialState: BusinessInformationState = {
    isLoaded: false,
    data: {
        businessKey: '',
        name: '',
        phone: '',
        email: '',
        address: EmptyAddress(),
    },
};

export const BusinessInfoFeatureName = 'BusinessInformation';

export const BusinessInfoFeature = createFeature({
    name: BusinessInfoFeatureName,
    reducer: createReducer(
        initialState,
        on(LoadBusinessInfoAction, (state) => state),
        on(
            SetBusinessInfoAction,
            (state, {
                name,
                phone,
                email,
                address,
                businessKey,
            }: BusinessInformation) => ({
                ...state,
                data: {
                    name,
                    phone,
                    email,
                    address,
                    businessKey,
                },
                isLoaded: true,
            })
        ),
        on(ResetBusinessInfoAction, () =>
            initialState
        )
    ),
});